import { styled } from '@mui/material';

export const Wrapper = styled('div')(({ columns }: { columns: boolean }) => ({
  display: 'flex',
  gap: '4px',
  width: '100%',
  flexDirection: columns ? 'column' : 'row',
  alignItems: columns ? 'flex-start' : 'center',
}));

export const IconWrapper = styled('span')(({ theme }) => ({
  width: 'fit-content',
  padding: '4px 12px',
  background: theme.palette.secondary.light,
  borderRadius: '6px',
}));
